console.log("script loaded");
// Zjistit, zda je dostupná funkce WebGL 2.0
var isWebGL2Supported = (function () {
    try {
      var canvas = document.createElement('canvas');
      return !!(
        window.WebGL2RenderingContext && (canvas.getContext('webgl2') || canvas.getContext('experimental-webgl2')));
    } catch (e) {
      return false;
    }
})();


import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { GLTFLoader } from 'thtd/GLTFLoader.js';
import { DRACOLoader } from 'thtd/DRACOLoader.js';

// Fork of rychidesign/thtd-three-setup script_na_web74.js (3D náhled běžných dresů).
// Vše (three, loadery, Draco dekodér, GLB modely, bump textura) je self-hostované
// v theme assets — viz importmap v snippets/head.liquid. ASSETS_BASE je adresář
// assets odvozený z URL tohoto modulu (Draco a modely se načítají bez ?v= parametru).
const ASSETS_BASE = new URL('.', import.meta.url).href;


function checkWebGLSupport(){
    const productModelEl = document.getElementById('product_model');
    if(isWebGL2Supported && productModelEl && productModelEl.innerHTML !== ''){
        init();
    }else{
        const wrapper3d = document.getElementById('3d_image_wrapper');
        const wrapperImage = document.getElementById('image_wrapper');
        if(wrapper3d){ wrapper3d.style.display = 'none'; };
        if(wrapperImage){ wrapperImage.style.display = 'block'; };
    };
};


if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", checkWebGLSupport);
  } else {
    checkWebGLSupport();
  }

function init(){
        /* Base =================================================================================*/

        // Canvas
        const canvas = document.getElementById('3d-canvas-02');
        const loaderWrapper = document.getElementById('loader-wrapper');
        const wrapper = document.querySelector('div.product_3d_wrapper');
        const productModel = document.getElementById('product_model').innerHTML;
        const productTextureEl = document.getElementById('product_texture_url');
        const productTextureUrl = productTextureEl && productTextureEl.getAttribute('src') ? productTextureEl.src : '';
        const productRotation = document.getElementById('product_rotation').innerHTML;
        const ambientColor = document.getElementById('product_ambient_color').innerHTML;
        const ambientIntensity = document.getElementById('product_ambient_intensity').innerHTML;


        /*
        // PRELOADER
        */
        // Render-on-demand: render jen když se kamera hýbe (controls.update()
        // vrací true) nebo když se změní scéna (thtdNeedsRender). Nepřetržitá
        // 60fps smyčka renderovala i statickou scénu — na zařízeních bez GPU
        // akcelerace (vč. Lighthouse/PSI serverů) to blokovalo main thread.
        let thtdNeedsRender = true;
        // Po dobu aktivního gesta (drag/pinch) renderujeme každý snímek — viz
        // 'start'/'end' listenery na controls. Spoléhat během gesta jen na
        // návratovou hodnotu update() je nespolehlivé (OrbitControls si update()
        // volá interně a změnu "spotřebuje" → ztracené snímky = zamrzlý zoom).
        let thtdInteracting = false;
        const loadingManager = new THREE.LoadingManager(
            //LOADED
            () =>
            {
                console.log('>> loaded <<');
                loaderWrapper.style.display = 'none';
                thtdNeedsRender = true;
            },
            //PROGRESS
            () =>
            {
                console.log('progress');
            }
        )


        // Scene
        const scene = new THREE.Scene();

        /* Loaders =================================================================================*/

        // Texture loader
        const textureLoader = new THREE.TextureLoader(loadingManager);

        // Draco loader
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath(ASSETS_BASE);

        // GLTF loader
        const gltfLoader = new GLTFLoader(loadingManager);
        gltfLoader.setDRACOLoader(dracoLoader);


        /* Lights =================================================================================*/

        // Spot light 01
        const spotLight = new THREE.SpotLight();
        spotLight.color = new THREE.Color(0xffffff);
        spotLight.intensity = 20;
        spotLight.position.y = 0.3;
        spotLight.position.x = 1.5;
        spotLight.position.z = 1;
        spotLight.castShadow = true;

        spotLight.shadow.mapSize.width = 512;
        spotLight.shadow.mapSize.height = 512;
        spotLight.shadow.camera.near = 0.5;
        spotLight.shadow.camera.far = 400;
        spotLight.shadow.focus = 1;

        scene.add(spotLight);


        // Back Spot light 02
        const spotLight02 = new THREE.SpotLight();
        spotLight02.color = new THREE.Color(0xffffff);
        spotLight02.intensity = 6;
        spotLight02.position.y = 0.5;
        spotLight02.position.x = -1;
        spotLight02.position.z = -2;
        //spotLight02.castShadow = true;
        scene.add(spotLight02);

        // Back Spot light 03
        const spotLight03 = new THREE.SpotLight();
        spotLight03.color = new THREE.Color(0xffffff);
        spotLight03.intensity = 6;
        spotLight03.position.y = 0.5;
        spotLight03.position.x = 1;
        spotLight03.position.z = -2;
        //spotLight03.castShadow = true;
        scene.add(spotLight03);

        const lightsGroup = new THREE.Group();
        lightsGroup.add(spotLight, spotLight02, spotLight03);
        scene.add(lightsGroup);


        // Ambient Spot light 03
        const AmbientLight = new THREE.AmbientLight();
        AmbientLight.color = new THREE.Color(ambientColor);
        AmbientLight.intensity = ambientIntensity;
        scene.add(AmbientLight);


        /* Textures =================================================================================*/

        //Long sleeve textures
        // Placeholder bez URL — textureLoader.load('') by stáhl celou produktovou
        // stránku jako obrázek (prázdný src atribut se resolvuje na URL stránky).
        const bakedTexture = productTextureUrl ? textureLoader.load(productTextureUrl) : new THREE.Texture();
        bakedTexture.flipY = false;
        bakedTexture.colorSpace = THREE.SRGBColorSpace;
        bakedTexture.minFilter = THREE.LinearFilter;
        const bumpTexture = textureLoader.load(ASSETS_BASE + 'bake_bump_2.jpg');
        bumpTexture.flipY = false;

        console.log("textures ready");

        /* Materials =================================================================================*/

        // Baked Long sleeve material
        const bakedMaterial = new THREE.MeshStandardMaterial({
            map: bakedTexture,
            roughness: 0.85,
            bumpMap: bumpTexture,
            bumpScale: 2.5,
            side: THREE.DoubleSide,
            color: new THREE.Color(0xffffff)
        });

        /* Model =================================================================================*/


        const dresGroup = new THREE.Group();

        let dresMesh;
        gltfLoader.load(ASSETS_BASE + productModel, (gltf) =>
            {
                dresMesh = gltf.scene;
                dresMesh.traverse((child) =>
                {
                    child.material = bakedMaterial;
                })
                dresGroup.add(dresMesh);
                dresMesh.visible = true;
                dresMesh.castShadow = true;
                dresMesh.receiveShadow = true;
            }
        )

        scene.add( dresGroup );
        dresGroup.rotation.y = Math.PI/10 * productRotation;


        /* Sizes =================================================================================*/

        const sizes = {
            width: wrapper.getBoundingClientRect().width,
            height: wrapper.getBoundingClientRect().height
        };

        window.addEventListener('resize', () =>
        {
            // Update sizes
            sizes.width = wrapper.getBoundingClientRect().width;
            sizes.height = wrapper.getBoundingClientRect().height;
            // Update camera
            camera.aspect = sizes.width / sizes.height
            camera.updateProjectionMatrix();
            // Update renderer
            renderer.setSize(sizes.width, sizes.height);
            renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
            renderer.render(scene, camera);
        });



        /* Camera =================================================================================*/

        // Base camera
        const camera = new THREE.PerspectiveCamera(30, sizes.width / sizes.height, 0.1, 100);
        camera.position.x = 0.26;
        camera.rotation.x = Math.PI /20;
        camera.position.y = -0.2
        camera.position.z = 1.2
        camera.add(lightsGroup);
        scene.add(camera);

        /* Renderer =================================================================================*/

        const renderer = new THREE.WebGLRenderer({
            canvas: canvas,
            antialias: true,
            alpha: true,
            shadowMapEnabled: true
        })
        renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        renderer.setSize(sizes.width, sizes.height);
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        renderer.outputColorSpace = THREE.SRGBColorSpace;
        renderer.outputEncoding = THREE.sRGBEncoding;


        const controls = new OrbitControls( camera, canvas );
        controls.enableDamping = true;
        controls.minDistance = 0.5;
        controls.maxDistance = 1.2;
        controls.enableZoom = false;
        controls.enablePan = false;
        controls.minPolarAngle = Math.PI / 4;
        controls.maxPolarAngle = Math.PI / 1.5;
        controls.dampingFactor = 0.1;
        // Render-on-demand: každá skutečná změna kamery si vyžádá render (i
        // damping po puštění). Během celého gesta renderuj každý snímek.
        controls.addEventListener('change', () => { thtdNeedsRender = true; });
        controls.addEventListener('start', () => { thtdInteracting = true; });
        controls.addEventListener('end',   () => { thtdInteracting = false; thtdNeedsRender = true; });
        // Android Chrome si u dvouprstého gesta rezervuje page-zoom a pointery
        // zruší (pointercancel) → zoom během pinche zamrzne. preventDefault na
        // multitouch řekne prohlížeči, že dvouprsté gesto obsluhujeme my.
        const thtdPreventMultiTouch = (e) => { if (e.touches.length > 1) e.preventDefault(); };
        canvas.addEventListener('touchstart', thtdPreventMultiTouch, { passive: false });
        canvas.addEventListener('touchmove',  thtdPreventMultiTouch, { passive: false });
        controls.update();
        if(sizes.width < 439){
            controls.enableZoom = true;
            renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        };

        /* Animate =================================================================================*/

        const tick = () =>
        {
            // Damping musí běžet každý snímek. Render řídíme přes flagy, ne přes
            // návratovou hodnotu update() (tu si OrbitControls při gestu spotřebuje).
            controls.update();
            if (thtdNeedsRender || thtdInteracting) {
                renderer.render(scene, camera);
                thtdNeedsRender = false;
            }
            // Call tick again on the next frame
            window.requestAnimationFrame(tick);
        }
        tick();
};
